jQuery(function($){

  // Toggle 'expanded' class on target
    $(document).on('click', '[data-expand]', function() {
        var target = $(this).attr('data-expand');
        $('[data-target="' + target + '"]').toggleClass('expanded');
    });

    // Remove 'active' class from target
    $(document).on('click', '[data-close]', function() {
        let target = $(this).data('close');
        $('[data-target="' + target + '"]').removeClass('active');
    });

    // Toggle 'active' class on target
    $(document).on('click', '[data-toggle]', function() {
        let target = $(this).data('toggle');
        $('[data-target="' + target + '"]').toggleClass('active');
    });

    // Toggle visibility of elements with the same data-toggle-self
    $(document).on('click', '[data-toggle-self]', function() {
        let target = $(this).attr('data-toggle-self');

        $(this).addClass('hidden');
        $('[data-toggle-self="' + target + '"]').not(this).removeClass('hidden');
    });

    $(document).on('click', '.stop-propagation', function(e){
        e.stopPropagation();
    });

    $(document).on('click', '.prevent-default', function(e){
        e.preventDefault();
    });


    $(document).on('click', '.toggle', function(e){
        const $this = $(this);
        $this.toggleClass('active');
    });

    

    // General function for one element triggering active on another
    $('[data-target]').on('click', function(){
        let target = $(this).data('target');
        let $target = $('[data-target-id="' + target + '"]');

        if ($target.length > 0){
            $target = $('.' + target);
        }

        if ($target.hasClass('active')){
            $target.removeClass('active');
        }
        else{
            $target.addClass('active');
        }

        if ($(this).data('remove')){
            $(this).remove();
        }
    });
});
